<template>

</template>

<script>

export default {
  name: 'StarterPage',

}
</script>
<style>
.ps {
  height: 100px;
}
</style>
